import { ColumnDataType, Provider, WorkflowComponentParamType } from '../types';
import { SelectWorkflowComponent } from './common/selectcomponent';
class GeneratePoints extends SelectWorkflowComponent {
    constructor() {
        super({
            name: 'native.generatepoints',
            group: 'Spatial Constructors',
            title: 'ST Generate Points',
            description: `
        This component generates a table with a specified number of random points contained within each polygon in the input table.
      `,
            starred: true
        }, [
            {
                name: 'source',
                type: WorkflowComponentParamType.InputTable,
                title: 'Source table'
            },
            {
                name: 'geo',
                type: WorkflowComponentParamType.Column,
                title: 'Geo column',
                parent: 'source',
                dataType: [ColumnDataType.Geography, ColumnDataType.Geometry]
            },
            {
                name: 'npoints',
                type: WorkflowComponentParamType.Number,
                title: 'Number of points',
                default: 100,
                min: 1,
                optional: true
            }
        ]);
        this.supportedProviders = [Provider.BigQuery];
    }
    getInnerSql({ params, connection, envVars }) {
        if (connection.type !== Provider.BigQuery) {
            return null;
        }
        return `WITH points AS (
              SELECT ${connection.quoteName(envVars.analyticsToolboxDataset)}.ST_GENERATEPOINTS(${params.geo}, ${params.npoints}) pts
              FROM ${connection.quoteName(params.source)}
            )
            SELECT geom
            FROM points, UNNEST(pts) geom`;
    }
    getVersion(provider) {
        return '2';
    }
    canProvideOutputSchemas() {
        return true;
    }
    getOutputSchema({ connection }) {
        return [
            {
                name: 'geom',
                type: connection.getGeoDataType()
            }
        ];
    }
}
export { GeneratePoints };
